const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the oauth transition Directive which defines the sign in form behavior and markup
 * @argument {Users} Users injected to access the Users resource
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('oauthTransition', ['Application', 'Authorization', 'Analyze', 'AuthorizationResource', '$translate', 'i18n', function (Application, Authorization, Analyze, AuthorizationResource, $translate, i18n) {
  return {
    restrict: 'E',
    template: require('../../../templates/directives/preauth/oauth-transition.html'),
    controller: async function () {

      if (Application.navigation.getPath() !== '/oauth-transition') {
        return;
      }
      var self = this;
      Authorization.signout(true);

      var params = Application.navigation.getUrlParameters();

      if (params.key && params.identifier) {

        self.loading = true;

        AuthorizationResource.oauth({key: params.key, identifier: params.identifier}, {}, async function(data) {
          if (Authorization.validateAndUseAuthToken(data)) {
            self.loading = false;
            Authorization.setActive();
            Analyze.record({resource: 'useragents'}, {useragent: Application.userAgent});
            Analyze.record({resource: 'authtokens'}, {token: Authorization.getAuthToken().token, action: 'signin'});
            Application.analyticsProvider.trackEvent('signin');
            var redirectPath = Application.storage.get('preRedirect');
            var redirectParamsLogin = Application.storage.get('redirectParams') || {};
            Application.storage.remove('redirectParams');
            var redirect = {};
            if (redirectParamsLogin.integration) {
              redirect.integration = redirectParamsLogin.integration;
            }
            // LANGUAGE
            if (Authorization.getAuthToken() && Authorization.getAuthToken().user && Authorization.getAuthToken().user.language) {
              i18n.language(Authorization.getAuthToken().user.language);
            }

            if (redirectPath) {
              Application.storage.remove('preRedirect');
              Application.navigation.goTo(redirectPath, redirect);
              return;
            }
            Application.navigation.goToHome();
          }
        }, async function() {
          self.loading = false;
          self.translations = await $translate(['modules.notifications.invalidCredentials']);
          Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCredentials'], duration: 5});
          Authorization.clearAuthToken();
          Application.notifications.setError(self.translations['modules.notifications.invalidCredentials']);
        });

      } else {
        self.translations = await $translate(['modules.notifications.invalidCredentials']);
        Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.invalidCredentials'], duration: 5});
        Authorization.clearAuthToken();
        Application.notifications.setError(self.translations['modules.notifications.invalidCredentials']);
      }

    },
    controllerAs: 'oauth'
  };
}]);
